export default __webpack_public_path__ + "static/media/hht1_ep02_timeline_q01_b.b498d129.png";